import React, { Component } from "react";
import "antd/dist/antd.css";
import { Table } from "antd";
import { itemRender, onShowSizeChange } from "../../../paginationfunction";
import "../../../antdstyle.css";
import { ToastContainer, toast } from "react-toastify";
import { Grid } from "react-loader-spinner";
import { baseurlImg } from "../../../../Components/BaseUrl";
import API from "../../../../utils/API";

import { connect } from "react-redux";

class AgencyProperties extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agencies: [],
      isLoading: false,
    };
  }

  componentDidMount() {
    const page = 1;
    const perPage = 10;
    this.fetchData(page, perPage);
  }

  fetchData = (page, perPage) => {
    this.setState({ isLoading: true });

    API.get(`/agency-properties?page=${page}&perPage=${perPage}`)
      .then(async (response) => {
        await response.data.agencies;
        this.setState({ isLoading: false, agencies: response.data.agencies });
      })
      .catch((e) => console.log("error"));
  };

  render() {
    const {lang} = this.props
    const columns = [
      {
        title: lang == "en" ? "Company Name" : "اسم الشركة",
        render: (text, record) =>
          lang == "en" ? record.name_en : record.name_ar,
      },
      {
        title: lang == "en" ? "Logo" : "الشعار",
        render: (text, record) => (
          <img
            style={{ height: "70px", width: "70px" }}
            src={baseurlImg + "/uploads/profiles/" + record.logo}
          />
        ),
      },

      {
        title: "Basic",
        dataIndex: "basic",
        sorter: (a, b) => a.basic.length - b.basic.length,
      },
      {
        title: "Featured",
        dataIndex: "featured",
        sorter: (a, b) => a.featured.length - b.featured.length,
      },
      {
        title: "Premium",
        dataIndex: "premium",
        sorter: (a, b) => a.premium.length - b.premium.length,
      },
      {
        title: "Mobile",
        dataIndex: "mobile",
        //sorter: (a, b) => a.mobile.length - b.mobile.length,
      },
      {
        title: "For Buy",
        render: (text, record) =>
          record.buy.length > 0 ? record.buy[0].buy_count : 0,
      },
      {
        title: "For Rent",
        render: (text, record) =>
          record.rent.length > 0 ? record.rent[0].rent_count : 0,
      },
    ];

    const handleTableChange = (pagination) => {
      this.fetchData(pagination.current, pagination.pageSize);
    };

    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Companies / Properties</h4>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                 
                      <Table
                        className="table-striped"
                        loading={this.state.isLoading}
                        onChange={handleTableChange}
                        pagination={{
                          pageSizeOptions: ["10", "20", "50", "100"],
                          total:
                            this.state?.agencies?.total > 0 &&
                            this.state.agencies.total,
                          pageSize: this.state.agencies.per_page,
                          current: this.state.agencies.current_page,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          showSizeChanger: true,
                          onShowSizeChange: onShowSizeChange,
                          itemRender: itemRender,
                        }}
                        style={{ overflowX: "auto", textAlign: "right" }}
                        columns={columns}
                        // bordered
                        dataSource={
                          this.state?.agencies?.data
                            ? this.state?.agencies?.data
                            : []
                        }
                        rowKey={(record) => record}
                      />
                 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  lang: state.auth.lang, 
});
export default connect(mapStateToProps)(AgencyProperties);

